import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Toaster } from "react-hot-toast";
import { afmsWorkspaceSx, cc } from "afms/theme/commandCenterTheme";
import LcpPortalSidebar from "./LcpPortalSidebar";

const SIDEBAR_WIDTH = 280;

/**
 * Chrome that wraps the LiftConnect Pro app — a permanent left rail at
 * every viewport size and a flex:1 content column on the right where the
 * routes render.
 *
 * The earlier version of this component switched to a hamburger + drawer
 * below 1200px; product wants the sidebar to ALWAYS be anchored, no
 * dismiss affordance, so we drop the mobile branch entirely. On very
 * narrow screens the content column gets squeezed — that's acceptable
 * vs. losing the nav.
 *
 * Mounted ONCE at the App.js level when pickSidebarVariant returns
 * "lcpPortal". Parallel to EnvironmentalPortalShell (Environmental).
 */
function LcpPortalShell({ children, onSwitchSystem }) {
  return (
    <Box
      className="lcp-portal-shell"
      sx={{
        ...afmsWorkspaceSx,
        display: "flex",
        minHeight: "100vh",
        bgcolor: cc.page,
        color: cc.ink,
      }}
    >
      <Box
        sx={{
          width: SIDEBAR_WIDTH,
          flexShrink: 0,
          borderRight: "1px solid rgba(255,255,255,0.08)",
          bgcolor: cc.navy,
          // Pin to the viewport. position:sticky + 100vh + alignSelf
          // flex-start keeps the bottom org/user card on screen even
          // when the main content scrolls.
          position: "sticky",
          top: 0,
          alignSelf: "flex-start",
          height: "100vh",
          overflowY: "auto",
        }}
      >
        <LcpPortalSidebar onSwitchSystem={onSwitchSystem} />
      </Box>
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
      <Toaster />
    </Box>
  );
}

LcpPortalShell.propTypes = {
  children: PropTypes.node,
  onSwitchSystem: PropTypes.func,
};

export default LcpPortalShell;
